export default class StateService {
  store = null

  constructor(store) {
    this.store = store
  }

  stateExists(state) {
    return this.store.getters['pointsImporterState/states'].includes(state)
  }

  hasState(state) {
    return (
      this.store.getters['pointsImporterState/stateContainer'][state] !== undefined &&
      this.store.getters['pointsImporterState/stateContainer'][state] !== false
    )
  }

  has(state) {
    return (
      this.store.getters['pointsImporterState/stateContainer'][state] !== undefined &&
      this.store.getters['pointsImporterState/stateContainer'][state] !== false
    )
  }

  get (state) {
    return this.store.getters['pointsImporterState/stateContainer'][state]
  }

  all() {
    return this.store.getters['pointsImporterState/stateContainer']
  }

  add(state, optionalData = true) {
    if (!this.stateExists(state)) {
      throw new Error(`State ${state} does not exist`)
    }
    this.store.dispatch('pointsImporterState/setState', { state, optionalData })
  }

  remove(state) {
    if (!this.stateExists(state)) {
      throw new Error(`State ${state} does not exist`)
    }
    this.store.dispatch('pointsImporterState/unsetState', state)
  }

  reset() {
    this.store.dispatch('pointsImporterState/resetState')
  }
}
